export interface CheckoutDiscountProfileAttributes {
  netAmountBeforeDiscount: number;
  netFirstPaymentAmountAfterPromotionalPeriod: number;
  discountPercentage?: number;
  discountTerm?: number;
}
